import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@components/common/Forms/Button/Button';


// Interface
// ********************************
interface CarouselArrowsProps {
  className?: string,
  chevronClassName?: string,
  onClick?: () => void,
  direction?: 'prev' | 'next',
}


// Helper variables
// ********************************
const buttonClasses = 'hidden absolute top-1/3 p-1 z-2 md:inline-block';
const chevronClasses = 'w-7 h-7';


/**
 * @description Renders the carousel arrows
 *
 * - **onClick** - function to be called when the arrow is clicked
 * - **direction** - direction of the arrow
 * - **className** - optional class name of the arrow
 * - **chevronClassName** - optional class name of the chevron
 */
export const CarouselArrows = (props: CarouselArrowsProps) => {
  const {
    className = '',
    chevronClassName,
    onClick,
    direction = 'prev',
  } = props;

  // Button placement class
  const buttonPlacement = direction === 'prev' ? 'left-0' : 'right-0';

  // Render the component
  // ********************************
  return (
    <Button
      styling="none"
      className={`${buttonClasses} ${buttonPlacement} ${className}`}
      onClick={onClick}
    >
      {
        direction === 'prev'
          ? <ChevronLeftIcon className={chevronClassName || chevronClasses} />
          : <ChevronRightIcon className={chevronClassName || chevronClasses} />
      }
    </Button>
  );
};
